/* eslint-disable camelcase */
import React from 'react';

import PropTypes from 'prop-types';

import getBuilderStateContentVariantData from '~/builder/utils/getBuilderStateContentVariantData';
import DesktopGridLayout from '~/gridv1_1/components/DesktopGridLayout';
import MobileGridLayout from '~/gridv1_1/components/MobileGridLayout';
import { CIOBrowseProvider } from '~/gridv1_1/context/CIOBrowseProvider';
import { GridInputProvider, GRID_TYPES } from '~/gridv1_1/hooks/useGridInputs';
import { useBreakpoint } from '~/techstyle-shared/react-components';

const BuilderConstructorGridV1_1 = ({
  assetContainer,
  builderState,
  categoryIdOverride,
  categorySelection,
  collectionIdOverride,
  collectionSelection,
  facet,
  facetOption,
  filterType,
  gridGender,
  gridHeader,
  gridStyleGuide,
  productSource,
  sideNav,
  sortOptions,
}) => {
  const { isMobile } = useBreakpoint();

  // This is to prevent content shift between SSR and CSR hydration
  if (typeof window === 'undefined') {
    return null;
  }

  const pageData = getBuilderStateContentVariantData({
    builderStateContent: builderState?.content,
  });
  const gridSpotlights = pageData?.gridSpotlights?.value?.data;

  return (
    <GridInputProvider
      value={{
        assetContainer,
        builderState,
        builderModel: builderState?.state?.modelName,
        categoryIdOverride,
        categorySelection,
        collectionIdOverride,
        collectionSelection,
        facet,
        facetOption,
        filterType,
        gridGender,
        gridHeader,
        gridSpotlights,
        gridStyleGuide,
        gridType: GRID_TYPES.BUILDER_CONSTRUCTOR_GRID,
        productSource,
        sideNav,
        sortOptions,
      }}
    >
      <CIOBrowseProvider>
        {isMobile ? <MobileGridLayout /> : <DesktopGridLayout />}
      </CIOBrowseProvider>
    </GridInputProvider>
  );
};

BuilderConstructorGridV1_1.propTypes = {
  assetContainer: PropTypes.shape({
    gridAssetContainer: PropTypes.string,
    gridAssetContainerMobile: PropTypes.string,
  }),
  builderState: PropTypes.object,
  categoryIdOverride: PropTypes.string,
  categorySelection: PropTypes.shape({
    value: PropTypes.string,
  }),
  collectionIdOverride: PropTypes.string,
  collectionSelection: PropTypes.shape({
    value: PropTypes.string,
  }),
  facet: PropTypes.string,
  facetOption: PropTypes.string,
  filterType: PropTypes.string,
  gridGender: PropTypes.string,
  gridHeader: PropTypes.string,
  gridStyleGuide: PropTypes.shape({
    tagList: PropTypes.string,
    assetContainers: PropTypes.shape({
      desktop: PropTypes.string,
      mobile: PropTypes.string,
      marketingCard: PropTypes.string,
    }),
  }),
  productSource: PropTypes.string,
  sideNav: PropTypes.shape({
    shouldShowCategoryNav: PropTypes.bool,
  }),
  sortOptions: PropTypes.array,
};

export default BuilderConstructorGridV1_1;
